module.exports = __webpack_public_path__ + "static/media/iamthatiam1.e07463f7.jpg";